import React, {Component} from 'react';
import {observer} from 'mobx-react';
import cloneDeep from 'lodash.clonedeep';
import {Radar, defaults} from 'react-chartjs-2';
import {AppStore, AggregateStore} from 'js/stores'; // singleton stores
import styles from 'css/screens/result.css';

@observer
/**
 * Score
 */
export default class Score extends Component {
  /**
   * constructor
   */
  constructor() {
    super();

    // chart.js settings
    defaults.global.tooltips.enabled = false;
    defaults.global.elements.point.radius = 0;
    defaults.global.animation.duration = 500;
    defaults.global.legend.display = false;
    defaults.global.layout.padding = 20;

    this.chartData = {
      labels: [],
      datasets: [
        {
          backgroundColor: 'rgba(254, 208, 208, .17)',
          borderColor: '#de0717',
          data: [],
          pointBackgroundColor: '#de0717',
          pointRadius: 3,
          borderWidth: 1,
        },
      ],
    };

    const {
      min,
      max,
    } = AppStore.selectRadarchart;
    const step = ('web' == AppStore.selectAppType ? 1 : 2);

    this.chartOptions = {
      scale: {
        ticks: {
          min: min,
          max: max,
          stepSize: step,
          display: false,
        },
        angleLines: {
          color: '#fafafa',
          lineWidth: 1,
        },
        gridLines: {
          color: '#ededed',
          lineWidth: 1,
        },
        pointLabels: {
          fontColor: '#333333',
          fontSize: 13,
        },
      },
    };

    this.chartSize = {
      w: 234,
      h: 234,
    };
  }

  /**
   * string to array
   * @param {string} text
   * @param {number} index
   * @return {array}
   */
  stringToArray(text, index) {
    const divide = [];

    divide.push(text.slice(0, index));
    divide.push(text.slice(index));

    return divide;
  }

  /**
   * get sp chart attributes
   * @param {object} base
   * @return {object}
   */
  getSpChartAttributes(base) {
    const params = cloneDeep(base);

    const labels = AggregateStore.scores.map((category) => {
      let name = '';
      switch (category.id) {
      case 2:
        name = this.stringToArray(category.name, 4);
        break;
      default:
        name = category.name;
        break;
      }
      return name;
    });

    params.data.labels = labels;
    params.options.scale.pointLabels.fontSize = 11;
    params.width = 220;
    params.height = 190;
    return params;
  }

  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    const labels = AggregateStore.scores.map((category) => {
      return category.name;
    });

    const scores = AggregateStore.scores.map((category) => {
      return category.yes;
    });

    this.chartData.labels = labels;
    this.chartData.datasets[0].data = scores;

    const radarAttributes = {
      data: this.chartData,
      options: this.chartOptions,
      height: this.chartSize.h,
      width: this.chartSize.w,
    };

    // pc用データをコピーして sp用に書き換える
    const spRadarAttributes = this.getSpChartAttributes(radarAttributes);

    return (
      <div className={styles.score}>
        <div className={styles.block}>
          <h3>市場創造PR力項目別スコア</h3>
          <div className={styles.scoreTable}>
            <div>
              <div className={styles.radarPc}>
                <Radar {...radarAttributes} />
              </div>
              <div className={styles.radarSp}>
                <Radar {...spRadarAttributes} />
              </div>
            </div>
            <div>
              <h4>市場創造に必要な4つのPR力</h4>
              <h5>1. 現状分析力</h5>
              <p>
                定量/定性的に自社と競合を分析し、
                適切なPR目的と目標に基づく市場創造に必要なPR戦略が立案できているかを診断しています。
              </p>
              <h5>2. ファクト開発力</h5>
              <p>
                自社や商品・サービスの価値を裏付ける根拠や実績、
                事例やデータなどを用意しているかどうかを診断しています。
              </p>
              <h5>3. ニュース素材化力</h5>
              <p>
                メディアやSNS上で取り上げられる素材をプレスツールやコンテンツにしているかどうかを診断しています。
              </p>
              <h5>4. 情報発信力</h5>
              <p>
                メディア露出に加えて、
                ソーシャルメディアやオウンドコンテンツ、
                ネイティブ広告などを用いて多面的に情報を発信しているかを診断しています。
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/screens/result/score.js